import angular from 'angular'

import { SaleSyncManager } from '../managers/sale-sync-manager'

/**
 * Initialises the saleSyncManager.
 *
 * @module webregister.resolvers.saleSyncManagerResolver
 */
angular
  .module('webregister.resolvers')
  .factory(
    'saleSyncManagerResolver',
    function (saleSyncManager: SaleSyncManager) {
      return saleSyncManager.init()
    }
  )
